// extracted by mini-css-extract-plugin
export default {"layoutContainer":"DJVgYR","configurationContainer":"KeXKGa","dataContainer":"JATvpT"};